import { fetchWithKeycloakToken } from '@/features/Keycloak/keycloakService';
import { toast } from 'sonner';

export async function executeRestJson(
  input: string | URL | globalThis.Request,
  init?: RequestInit,
) {
  return await executeRest(input, {
    ...init,
    headers: {
      'Content-Type': 'application/json',
      ...init?.headers,
    },
  });
}

export async function executeRestForm(
  input: string | URL | globalThis.Request,
  init?: RequestInit,
) {
  return await executeRest(input, init);
}

async function executeRest(
  input: string | URL | globalThis.Request,
  init?: RequestInit,
) {
  try {
    const response = await fetchWithKeycloakToken(input, init);

    if (!response.ok) {
      const errorBody = await response.text();
      toast.error(`HTTP error ${response.status} in executeRest`, {
        duration: 3000,
        description: errorBody,
      });
      throw new Error(`HTTP error ${response.status}: ${errorBody}`);
    }

    return response;
  } catch (error) {
    console.error('Error in executeRest:', error);
    toast.error('Error in executeRest:', {
      duration: 3000,
      description: error,
    });
    throw error;
  }
}
